import { compose } from 'ramda';

import connect from 'app/libs/connect';
import wrapIn from 'app/enhancers/wrapIn';
import { clientReturnUrl } from 'app/features/checkout/selectors';
import {
  titleKey,
  subtitleKey,
} from 'app/features/alreadyPremium/heroBlock/selectors';
import BlockWrapper from 'app/features/success/components/BlockWrapper';
import { UI } from 'app/features/success/heroBlock/components/HeroBlock';

const HeroBlock = compose(
  connect({ clientReturnUrl, titleKey, subtitleKey }),
  wrapIn(BlockWrapper),
)(UI);

export default HeroBlock;
